/**
 * API auth status codes and user-facing messages.
 * Use getAuthMessage(code) so OTP sent, OTP failed, not verified, verified, user not found, etc.
 * show consistent messages across login, signup, reset password, invite, and verification flows.
 */
export const AUTH_STATUS_MESSAGES = {
  USER_NOT_FOUND: "User not found.",
  INVALID_CREDENTIALS: "Invalid email or password.",
  ACCOUNT_LOCKED: "Account is locked. Please contact support.",
  ACCOUNT_DISABLED: "Account is disabled. Please contact support.",
  EMAIL_REQUIRED: "Email is required.",
  RESET_PASSWORD_LINK_SENT: "Reset link sent. Please check your email.",
  RESET_TOKEN_REQUIRED: "Reset token is required.",
  NEW_PASSWORD_REQUIRED: "New password is required.",
  PASSWORD_RESET_SUCCESS: "Password reset successful. Please sign in.",
  LOGIN_SUCCESS: "Signed in successfully.",
  EMAIL_ALREADY_EXISTS: "An account with this email already exists.",
  RESEND_TOO_SOON: "Please wait before requesting another code.",
  OTP_SENT: "Verification code sent. Please check your email.",
  EMAIL_OTP_REQUIRED: "Please enter the verification code sent to your email.",
  ALREADY_VERIFIED: "This email is already verified.",
  OTP_EXPIRED: "Verification code has expired. Please request a new one.",
  INVALID_OTP: "Invalid verification code. Please try again.",
  VERIFIED: "Your email is verified. You can now start your free trial.",
  PASSWORD_REQUIRED: "Password is required.",
  EMAIL_NOT_FOUND: "No account found with this email.",
  EMAIL_NOT_VERIFIED: "Please verify your email first.",
  USER_REGISTERED: "Account created. Please sign in.",
  LOGGED_OUT: "You have been signed out.",
  TOKEN_REQUIRED: "Session expired. Please sign in again.",
  INVALID_TOKEN: "Invalid or expired link. Please try again.",
  INVITE_ALREADY_USED: "This invite has already been used.",
  INVITE_TOKEN_EXPIRED: "This invite link has expired.",
  ALREADY_APPROVED: "Already approved.",
  LINK_EXPIRED: "This link has expired. Please request a new one.",
  INVALID_ACTION_TYPE: "Invalid action.",
  APPROVED_SUCCESS: "Approved successfully.",
  USERNAME_REQUIRED: "Email or username is required.",
}

/**
 * Returns user-facing message for an API status code or raw message.
 * If the value matches a known code, returns the mapped message; otherwise returns the original.
 * @param {string} codeOrMessage - API code (e.g. INVALID_CREDENTIALS) or any error message
 * @returns {string}
 */
export function getAuthMessage(codeOrMessage) {
  if (codeOrMessage == null || String(codeOrMessage).trim() === "") return ""
  const key = String(codeOrMessage).trim().toUpperCase()
  if (AUTH_STATUS_MESSAGES[key]) return AUTH_STATUS_MESSAGES[key]
  return codeOrMessage
}
